import { Form } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../utilz/i18n';
import CommonModal from '../../../components/Modals/CommonModal';
import AddProductFullForm from './AddProductFullForm';

// TODO: move to claims folder
const AddProductFullModal = ({ addressBookModal, handleAddressBookModalClose, onSelectAddressBook }) => {
  const [form] = Form.useForm();
  const { saveProduct } = useSelector((state) => state.shipment);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <CommonModal
      title={t('translation:default.fields.addNewProduct')}
      open={addressBookModal}
      className="h-auto vw-70"
      okText={t('translation:default.buttons.add')}
      cancelText={t('translation:default.buttons.cancel')}
      onOk={() => form.submit()}
      onClose={handleAddressBookModalClose}
      onCancel={handleAddressBookModalClose}
      okLoading={saveProduct?.progressing}
    >
      <AddProductFullForm formInstance={form} handleSuccess={onSelectAddressBook} />
    </CommonModal>
  );
};

export default AddProductFullModal;
